module.exports = __webpack_public_path__ + "img/pronation.a521a472.png";